import { FileDownload } from '@mui/icons-material';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useContext } from 'react';

import { UserContext } from '~/auth/userContext';
import Skeleton from '~/components/common/Skeleton';
import { formatLocaleDateNumeric } from '~/components/compliance/formatters';
import { useCarCertificates } from '~/components/compliance/useCarCertificate';

const formatString = (str?: string) => {
  return str
    ? str
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    : 'N/A';
};
export const ComplianceDocuments = ({ carId }: { carId: string }) => {
  const { certificates, isLoading } = useCarCertificates(carId);
  const { locale } = useContext(UserContext);

  if (isLoading) {
    return (
      <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        <Table aria-label="certificates table" size="small">
          <TableHead>
            <TableRow>
              <TableCell> Type</TableCell>
              <TableCell>Date Issued</TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {[1, 2, 3].map((index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton width={120} />
                </TableCell>
                <TableCell>
                  <Skeleton width={100} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="circular" width={32} height={32} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
      <Table aria-label="certificates table" size="small">
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Date Issued</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {certificates.map((cert, index) => (
            <TableRow key={index}>
              <TableCell>{formatString(cert.documentType)}</TableCell>
              <TableCell>{formatLocaleDateNumeric(cert.dateIssued, locale, '—')}</TableCell>
              <TableCell align="right">
                {cert.downloadUrl ? (
                  <IconButton size="small" href={cert.downloadUrl} target="_blank" download>
                    <FileDownload fontSize="small" />
                  </IconButton>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
          {certificates.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  No Compliance Documents
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
